import { useFetchCompanyUsersQuery } from "api/usersApi";
import React from "react";
import { Table, Card, CardHeader, CardBody, CardTitle } from "reactstrap";

function EmployeesTable({ companyId }) {
  const {
    data: companyUsersData = [],
    isLoading,
    error,
  } = useFetchCompanyUsersQuery();
  const employees = Array.isArray(companyUsersData) ? companyUsersData : [];

  if (isLoading) return <div>Loading employees...</div>;
  if (error) return <div>Error loading employees.</div>;

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h4">Employees</CardTitle>
      </CardHeader>
      <CardBody>
        <Table className="tablesorter" responsive>
          <thead className="text-primary">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            {employees.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No employees found.
                </td>
              </tr>
            ) : (
              employees.map(({ id, username, email, role, active }) => (
                <tr key={id}>
                  <td>{username}</td>
                  <td>{email || "—"}</td>
                  <td>{role}</td>
                  <td className="text-center">
                    {active ? "Active" : "Inactive"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}

export default EmployeesTable;
